<div class="ajax-loading ajax-popup-loading"><div class="loading-icon"></div></div>
<div class="mat-dialog-title" mat-dialog-title="">
    <h2>{{consumer.id != null && consumer.id.length > 0 ? "Edit API Consumer" : "Add API Consumer"}}</h2>
    <button mat-button mat-dialog-close class="close">Cancel</button>
</div>
<form (ngSubmit)="saveConsumer()">
    <div mat-dialog-content class="example-container">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Name <span class="required">*</span></mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="Name"
                                [formControl]="name" name="name" [(ngModel)]="consumer.name" />
                        <mat-error *ngIf="name.invalid">Name is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Email</mat-label>
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="Email"
                                [formControl]="email" name="email" [(ngModel)]="consumer.email" />
                        <mat-error *ngIf="email.errors?.['email']">Invalid Email</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Description</mat-label>
                    <mat-form-field>
                        <textarea matInput placeholder="Description" [formControl]="description" name="lastName" [(ngModel)]="consumer.description" rows="2"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <mat-label>Unique Key <span class="required">*</span></mat-label>
                    <div style="display: flex; align-items: center;">
                        <mat-form-field>
                            <textarea matInput placeholder="Unique Key" [formControl]="uniqueKey" rows="2" name="uniqueKey" [(ngModel)]="consumer.uniqueKey"></textarea>
                            <mat-error *ngIf="uniqueKey.invalid">Unique key is required</mat-error>
                        </mat-form-field>
                        <button mat-icon-button color="primary" [hidden]="consumer.id == null || consumer.id.length <= 0" (click)="getConsumerKey()" type="button" matTooltip="Refresh unique key" style="margin-bottom: 25px;width: 40px;"><mat-icon class="text-dark">refresh</mat-icon></button>
                        <button mat-icon-button color="primary" (click)="copyText(this.consumer.uniqueKey??'','Unique key')" type="button" matTooltip="Copy unique key" style="margin-bottom: 25px;width: 40px;"><mat-icon class="text-dark">content_copy</mat-icon></button>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    
                </div>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="row">
        <div class="col-12">
            <div class="text-center py-3 d-flex  justify-content-center"> 
                <button mat-raised-button color="primary" (click)="closeDialog()" type="button" class="btn-outline-black me-3">Cancel </button>
                <button mat-raised-button color="primary" type="submit" class=" btn-black ">Save </button>&nbsp;&nbsp;                
            </div>
        </div>
    </div>
</form>
